import { UserFormValues } from '../../types'

interface Args {
  formValues: UserFormValues
  weekStartsOn: uui.domain.WeekStartsOn
  userConfiguration: uui.domain.UserConfiguration
}

type CourierFilterEntry = {
  driverIds: string[]
  vehicleIds: string[]
}

export function createCreateUserPayload(
  args: Args,
): uui.domain.actions.rpc.user.CreateUserAction['payload'] {
  const { formValues, userConfiguration, weekStartsOn } = args
  const {
    name,
    surname,
    username,
    email,
    territoryFilter: territoryFilterValue,
    type,
    limitedAccess,
    courierFilter,
    companies: companiesValue,
    isCompanyFiltered,
    vehicles,
    drivers,
  } = formValues

  const companies = companiesValue.map(company => company.id)

  const newPassword = formValues['new-password']

  let territoryFilter: string[]

  switch (type) {
    case 'courier':
      territoryFilter = courierFilter
      break

    default:
      territoryFilter =
        limitedAccess === false ? ['*'] : territoryFilterValue.map(territory => territory.id)
      break
  }

  const courierFilterData = (courierFilter || []).reduce<Record<string, CourierFilterEntry>>(
    (acc, filterId) => {
      const driverIds = drivers?.[filterId]?.ids || []
      const vehicleIds = vehicles?.[filterId]?.ids || []

      acc[filterId] = {
        driverIds: driverIds.length > 0 ? driverIds : ['*'],
        vehicleIds: vehicleIds.length > 0 ? vehicleIds : ['*'],
      }

      return acc
    },
    {},
  )

  const baseParams = {
    name,
    surname,
    username,
    enabled: true,
    email,
    territoryFilter,
    settings: userConfiguration,
    uiData: {
      version: 1 as const,
      exportOrders: {
        format: 'CSV' as 'CSV' | 'XLSX',
        includeBarcodes: true,
      },
      exportRoutes: {
        format: 'CSV' as 'CSV' | 'XLSX',
        includePod: true,
        includeBarcodes: true,
      },
      weekStartsOn,
    },

    companies,
    isCompanyFiltered,
  }

  const user =
    type === 'courier'
      ? {
          type,
          ...baseParams,
          courierFilter: courierFilterData,
        }
      : { type, ...baseParams }

  return {
    user,
    password: newPassword,
  }
}
